"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Party;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactIntl = require("react-intl");

var _PartyModule = _interopRequireDefault(require("./Party.module.scss"));

var _Button = _interopRequireDefault(require("../../../../inputElements/Button/Button"));

var _WindowControls = _interopRequireDefault(require("../../../../windows/WindowControls/WindowControls"));

var _EButtonType = _interopRequireDefault(require("../../../../inputElements/Button/EButtonType"));

var _Party = _interopRequireDefault(require("./Party.i18n"));

var _MemberEntry = _interopRequireDefault(require("./components/MemberEntry/MemberEntry"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function Party(_ref) {
  var _ref$viewType = _ref.viewType,
      viewType = _ref$viewType === void 0 ? "NO_PARTY" : _ref$viewType,
      _ref$members = _ref.members,
      members = _ref$members === void 0 ? [] : _ref$members,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? "" : _ref$name,
      _ref$level = _ref.level,
      level = _ref$level === void 0 ? 1 : _ref$level,
      _ref$expBullCount = _ref.expBullCount,
      expBullCount = _ref$expBullCount === void 0 ? 0 : _ref$expBullCount,
      _ref$isSharingItems = _ref.isSharingItems,
      isSharingItems = _ref$isSharingItems === void 0 ? true : _ref$isSharingItems,
      _ref$isSharingMoney = _ref.isSharingMoney,
      isSharingMoney = _ref$isSharingMoney === void 0 ? true : _ref$isSharingMoney,
      _ref$showEnergyValues = _ref.showEnergyValuesOnHover,
      showEnergyValuesOnHover = _ref$showEnergyValues === void 0 ? false : _ref$showEnergyValues,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  var _useState = (0, _react.useState)("FULL"),
      _useState2 = _slicedToArray(_useState, 2),
      view = _useState2[0],
      setView = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedMemberIndex = _useState4[0],
      setSelectedMemberIndex = _useState4[1];

  var toggleView = (0, _react.useCallback)(function () {
    if (view === "FULL") {
      setView("MEMBERS_ONLY");
    } else if (view === "MEMBERS_ONLY") {
      setView("MINIMIZED");
    } else if (view === "MINIMIZED") {
      setView("FULL");
    }
  }, [view]);
  var renderSharingButtons = (0, _react.useCallback)(function () {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_PartyModule.default.btn, _PartyModule.default.fifth)
    }, isSharingMoney && /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: _EButtonType.default.HI_MONEY,
      isDisabled: viewType !== "LEADER"
    }), !isSharingMoney && /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: _EButtonType.default.DEF_MONEY,
      isDisabled: viewType !== "LEADER"
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_PartyModule.default.btn, _PartyModule.default.sixth)
    }, isSharingItems && /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: _EButtonType.default.HI_ITEM,
      isDisabled: viewType !== "LEADER"
    }), !isSharingItems && /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: _EButtonType.default.DEF_ITEM,
      isDisabled: viewType !== "LEADER"
    })));
  }, [isSharingItems, isSharingMoney, viewType]);
  var renderControlsLeader = (0, _react.useCallback)(function () {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_PartyModule.default.btn, _PartyModule.default.first)
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: _EButtonType.default.INVITE
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_PartyModule.default.btn, _PartyModule.default.second)
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: _EButtonType.default.EXPULSION
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_PartyModule.default.btn, _PartyModule.default.third)
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: _EButtonType.default.TRANSFER
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_PartyModule.default.btn, _PartyModule.default.fourth)
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: _EButtonType.default.DISSOLUTION
    })), renderSharingButtons());
  }, [renderSharingButtons]);
  var renderControlsMember = (0, _react.useCallback)(function () {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_PartyModule.default.btn, _PartyModule.default.fourth)
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: _EButtonType.default.SECESSION
    })), renderSharingButtons());
  }, [renderSharingButtons]);
  var renderControls = (0, _react.useCallback)(function () {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _PartyModule.default.controls
    }, viewType === "LEADER" && renderControlsLeader(), viewType === "MEMBER" && renderControlsMember(), viewType === "NO_PARTY" && /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_PartyModule.default.btn, _PartyModule.default.fifth)
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: _EButtonType.default.NEW_PARTY_55X27
    }, formatMessage(_Party.default.create))));
  }, [formatMessage, renderControlsLeader, renderControlsMember, viewType]);
  var renderActualWindow = (0, _react.useCallback)(function () {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _PartyModule.default.content
    }, /*#__PURE__*/_react.default.createElement(_WindowControls.default, {
      classNameDragHandler: _PartyModule.default.dragHandler,
      hasCloseBtn: false
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: _PartyModule.default.name
    }, name), /*#__PURE__*/_react.default.createElement("div", {
      className: _PartyModule.default.btnFind
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: _EButtonType.default.PARTYFIND2
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: _PartyModule.default.expBar
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_PartyModule.default.fill, _PartyModule.default["bulls-".concat(expBullCount)])
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: _PartyModule.default.level
    }, formatMessage(_Party.default.lv), " ", level), renderControls());
  }, [expBullCount, formatMessage, level, name, renderControls]);
  var renderMembers = (0, _react.useCallback)(function () {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _PartyModule.default.members
    }, members.map(function (member, index) {
      return /*#__PURE__*/_react.default.createElement(_MemberEntry.default, {
        key: member.id,
        character: member,
        isSelected: index === selectedMemberIndex,
        onSelect: function onSelect() {
          return setSelectedMemberIndex(index);
        },
        showEnergyValuesOnHover: showEnergyValuesOnHover
      });
    }));
  }, [members, selectedMemberIndex, showEnergyValuesOnHover]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_PartyModule.default.window, _PartyModule.default[view], view !== "FULL" && _PartyModule.default.minimized, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _PartyModule.default.btnHide
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.PARTY_ICON,
    onClick: toggleView
  })), view === "FULL" && renderActualWindow(), view !== "MINIMIZED" && renderMembers());
}